export default () => {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_48_451)">
        <path
          d="M7.85002 3H11.7L8.85002 0.6C8.75002 0.55 8.60002 0.5 8.50002 0.5H6.90002L7.85002 3Z"
          fill="white"
        />
        <path
          d="M8 4V7.5H4V4H0V12C0 12.3 0.2 12.5 0.5 12.5H11.5C11.8 12.5 12 12.3 12 12V4H8Z"
          fill="white"
        />
        <path
          d="M4.15005 3L5.10005 0.5H3.50005C3.40005 0.5 3.25005 0.55 3.20005 0.6L0.300049 3H4.15005Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_48_451">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
